import { Check, Minus } from "lucide-react";

const Y = true;
const GROUPS = [
  ["Worldbuilding", [
    ["Worlds", "2", "Unlimited"],
    ["Wiki pages, sections, infoboxes, galleries and rich text", Y, Y],
    ["Timeline, relationship map, family tree, shipping chart, tree of life", Y, Y],
    ["Page history and a read-only share link", Y, Y],
    ["Invite co-writers with roles, a review queue, comments and @mentions", false, Y],
  ]],
  ["Writing desk", [
    ["Works", "3", "Unlimited"],
    ["Chapters, autosave, daily word goals and streaks", Y, Y],
    ["Fanfic details, statuses, filters and collections", Y, Y],
    ["Book-style pages, fonts, chapter images and work notes", Y, Y],
    ["Scene break designs", "The asterism", "Every design"],
  ]],
  ["Make it yours", [
    ["Themes", "Dark and Light", "Every preset"],
    ["Your own themes: colours, fonts, corners and texture", false, Y],
  ]],
  ["Billing", [
    ["Monthly or yearly, cancel anytime", false, Y],
    ["Send Pro as a gift", Y, Y],
  ]],
];

const Cell = ({ v, pro }) => {
  if (v === true) return <Check className={`w-4 h-4 mx-auto ${pro ? "text-amber-400" : "text-slate-300"}`} aria-label="Included" />;
  if (v === false) return <Minus className="w-4 h-4 mx-auto text-slate-600" aria-label="Not included" />;
  return <span className={`text-xs sm:text-sm ${pro ? "text-amber-200" : "text-slate-300"}`}>{v}</span>;
};

export const PlanCompare = () => (
  <div className="overflow-hidden rounded-2xl border border-line" data-testid="plan-compare">
    <table className="w-full text-sm">
      <thead>
        <tr className="bg-panel">
          <th className="text-left font-normal text-slate-500 px-4 sm:px-6 py-4 w-[55%]"><span className="sr-only">Feature</span></th>
          <th className="font-display text-xl text-slate-100 px-2 py-4">Free</th>
          <th className="font-display text-xl text-amber-300 px-2 py-4 bg-amber-500/5">Pro</th>
        </tr>
      </thead>
      {GROUPS.map(([g, rows]) => (
        <tbody key={g} data-testid={`plan-compare-${g.toLowerCase().replace(/\s+/g, "-")}`}>
          <tr><th colSpan={3} className="text-left font-code text-[10px] uppercase tracking-[0.3em] text-amber-500/80 px-4 sm:px-6 pt-6 pb-2">{g}</th></tr>
          {rows.map(([label, free, pro]) => (
            <tr key={label} className="border-t border-line/70">
              <td className="px-4 sm:px-6 py-3 text-slate-300">{label}</td>
              <td className="px-2 py-3 text-center"><Cell v={free} /></td>
              <td className="px-2 py-3 text-center bg-amber-500/5"><Cell v={pro} pro /></td>
            </tr>
          ))}
        </tbody>
      ))}
    </table>
  </div>
);
